import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { spacing4x, spacing2x, spacing3x } from '../../styles/spacing.js';
import { ButtonMenu } from '../ButtonMenu/ButtonMenu.js';
import { CardBase } from '../CardBase/CardBase.js';
import { CardTitle } from '../CardBase/CardTitle.js';
import { Checkbox } from '../Checkbox/Checkbox.js';
import { IconMore } from '../Icons/IconMore.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["buttonMenuProps", "checkboxProps", "titleProps"],
    _excluded2 = ["buttonProps"];
var FolderCard = /*#__PURE__*/React.forwardRef(function FolderCard2(props, ref) {
  var buttonMenuProps = props.buttonMenuProps,
      checkboxProps = props.checkboxProps,
      titleProps = props.titleProps,
      rest = _objectWithoutProperties(props, _excluded);

  var buttonProps = buttonMenuProps.buttonProps,
      menuProps = _objectWithoutProperties(buttonMenuProps, _excluded2);

  var selectable = !!checkboxProps;
  return /*#__PURE__*/jsx(CardBase, _objectSpread(_objectSpread({}, rest), {}, {
    areas: ["a b c d"],
    columns: ["auto", "1fr", "auto", "52px"],
    rows: ["52px"],
    items: [{
      area: "a",
      align: "center",
      justify: "start",
      style: {
        lineHeight: 0,
        paddingInlineStart: spacing4x,
        paddingInlineEnd: selectable ? spacing2x : void 0
      },
      children: selectable ? /*#__PURE__*/jsx(Checkbox, _objectSpread({}, checkboxProps)) : void 0
    }, {
      area: ["a", "b", "a", "c"],
      align: "center",
      children: /*#__PURE__*/jsx(CardTitle, _objectSpread({}, titleProps))
    }, {
      area: "d",
      align: "center",
      justify: "end",
      style: {
        paddingInlineStart: spacing4x,
        paddingInlineEnd: spacing3x
      },
      children: /*#__PURE__*/jsx(ButtonMenu, _objectSpread({
        buttonProps: _objectSpread({
          hideLabel: true,
          startAdornment: IconMore,
          variant: "ghost"
        }, buttonProps)
      }, menuProps))
    }],
    ref: ref,
    selected: checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.checked,
    style: {
      height: 52,
      maxWidth: 216
    }
  }));
});
FolderCard.propTypes = {
  "buttonMenuProps": _PropTypes.shape({
    "buttonProps": _PropTypes.object.isRequired,
    "children": _PropTypes.node,
    "containerSelector": _PropTypes.string,
    "inline": _PropTypes.bool,
    "maxHeight": _PropTypes.number,
    "offset": _PropTypes.object,
    "onActivate": _PropTypes.func,
    "onHide": _PropTypes.func,
    "onShow": _PropTypes.func,
    "options": _PropTypes.arrayOf(_PropTypes.object).isRequired,
    "placementLocked": _PropTypes.bool,
    "position": _PropTypes.oneOf(["left", "right"]),
    "returnFocusRef": _PropTypes.shape({
      "current": _PropTypes.any.isRequired
    }),
    "showing": _PropTypes.bool,
    "tooltipProps": _PropTypes.object,
    "zIndex": _PropTypes.number
  }).isRequired,
  "checkboxProps": _PropTypes.object,
  "titleProps": _PropTypes.object.isRequired
};
FolderCard.displayName = "FolderCard";

export { FolderCard };
